import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {'small' | null} [size]
 * @prop  {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [href]
 * @prop {() => void} [onClick]
 * @prop {'submit' | 'reset' | 'button'} [type]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifFab = props => {
  const {
    children,
    disabled = false,
    href = '',
    onClick = null,
    size = null,
    type = 'submit',
    className = '',
    ...other
  } = props;
  const classes = classNames({
    'motif-fab': true,
    'motif-fab-size-small': size === 'small',
    [className]: true
  });

  return (
    <React.Fragment>
      {href && (
        <a {...other} href={href} className={classes} data-motif-fab>
          {children}
        </a>
      )}
      {!href && (
        <button {...other} type={type} className={classes} disabled={disabled} onClick={onClick} data-motif-fab>
          {children}
        </button>
      )}
    </React.Fragment>
  );
};

MotifFab.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  size: PropTypes.oneOf(['small', null]),
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  onClick: PropTypes.func
};

export { MotifFab };
